import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FrontendModalService } from '@tablesready/frontend-modal';
import { FrontendModalHeaderDirective } from './frontend-modal-header.directive';
import { FrontendModalContentDirective } from './frontend-modal-content.directive';
import { FrontendModalFooterDirective } from './frontend-modal-footer.directive';

@NgModule({
  declarations: [
    FrontendModalHeaderDirective,
    FrontendModalContentDirective,
    FrontendModalFooterDirective
  ],
  imports: [CommonModule],
  providers: [FrontendModalService],
  exports: [
    FrontendModalHeaderDirective,
    FrontendModalContentDirective,
    FrontendModalFooterDirective,
  ],
})
export class FrontendModalModule {}
